import { SIF_IDENTIFIERS } from '../../utils';

export const getFormattedCode = (codeValue: string) => {
    const codeKey = Object.keys(SIF_IDENTIFIERS)?.find((key) => SIF_IDENTIFIERS[key] === codeValue) || '';
    return codeKey ? `${codeKey} - ${codeValue}` : `${codeValue}`;
};
